export const ELIGIBILITY_MAX = 100;
export const ELIGIBILITY_LIMIT = 10;

export type EligibilityCriterionField = {
  id: string;
  text?: string;
};

export type SortableEligibilityRowProps = {
  field: EligibilityCriterionField;
  index: number;
  onRemove: (index: number) => void;
};
